import { Combinatorics } from "./combinatorics";
import Hashtable from "./hashtable";
import $ from 'jquery';

/* eslint-disable */
export var preFact = new Array(100);

//Vettori utili al calcolo delle combinazioni
export var EV = [];
export var ES = [];
export var F = [];
export var IA = [];
export var PrecalculateComb = [];
export var SingleCombCount = [];
export var FinalcalculateComb = [];
export var OddsComb = [];
export var OddsCombForWinning = [];

export var oldSetLength = 0;
export var oldFixedevent = 0;

export var result2 = [];
export var countCombination = new Array(31);
export var extraQuoteCombination = new Array(31);

export var validCombination = new Array(30);
export var winningAmount = 0;
export var minWinningAmount = 0;
export var maxSystemWinning = new Array(31);

//vettori per accumulazione delle quote delle combinazioni
export var _systemCombinationsOdds = [];
//vettori per il bonus delle combinazioni
export var _systemCombinationsBonus = [];
//vettore per il conteggio delle combinazioni 
export var _systemCombinationsCount = [];
//vettore delle quote fisse
export var _systemFixedArray = [];
//vettore delle combinazioni
export var _systemCombinations = [];
export var fixedArray = [];

export var syspartecipabonus = new Array(30);
export var nr_mult_con_nr_flag_bonus_sup_min_avv = 0;
export var nr_mult_tutti_flag_bonus_on = 0;
export var max_nAvvValidi = 0;
export var rissys = new Object();
export var v_vin_pot_max = new Array(31);
export var v_maxpotbonus = new Array(31);
export var v_minpotbonus = new Array(31);
export var importicomb = new Array(31);
export var _bonusSystem = null;
export var _systemCombinationsBonusNetti = null;
export var _systemArray = null;
export var _systemCombinationsCountTotal = 0;
export var _systemCombinationsTotalAmount = 0;
export var _maxSystemWinning = 0;

/////////////////////////////////////////////////
/////////////////////////////////////////////////
/////////////////////////////////////////////////
//Tronca il numero senza arrotondare, a un numero di decimali pari a decimals
export function truncateDecimal(number, decimals) {

  if (isNaN(number) || number.toString().indexOf("-") != -1)
    number = 0;
  var stringOfnumber = parseFloat(number);
  //  return stringOfnumber.toFixed(decimals + 1).split(".")[0] + "." + stringOfnumber.toFixed(3).split(".")[1].substr(0, decimals);
  return stringOfnumber.toFixed(decimals + 1).split(".")[0] + "." + stringOfnumber.toFixed(8).split(".")[1].substr(0, decimals);

}

export function spacchettaAccSys(acc) {
  var o = new Object();
  var v = acc.split("|");
  //aggiunto v[6] : h1
  o.bet = v[0] + "|" + v[1] + "|" + v[2] + "|" + v[3] + "|" + v[4] + "|" + v[5] + "|" + v[6];
  o.betarr = acc;
  o.betblock = v[0] + "_" + v[1];

  //var bet = idManif + "|" + idAvv + "|" + idScomm + "|" + idEve + "|" + quota + "|" + tiposport + "|" + h1;
  //var datiaccessori = bet + "|" + descrScomm + "|" + descrAvv + "|" + descrEve + "|" + palavvscomm + "|" + islista + "|" + h1 + "|" + disc + "|" + dataS + "|" + class_sp + "|" + tipo_m_a;

  o.idManif = v[0];
  o.eventId = v[1]; // idavv
  o.idScomm = v[2];
  o.idEve = v[3];
  o.quota = v[4];
  o.odd = v[4] / 100;
  o.tiposport = v[5];
  o.h1 = v[6];
  o.descrScomm = v[7];
  o.descrAvv = v[8];
  o.descrEve = v[9];
  o.pal = v[10];
  o.avv = v[11];
  o.scomm = v[12];
  o.islista = v[13];
  o.handicap = v[14];
  o.disciplina = v[15];
  o.dataS = v[16];
  o.class_sp = v[17];
  o.tipo_m_a = v[18];
  o.fissa = v[20];
  o.includeForMaxWinningSystem = 0;
  o.partecipabonus = false;

  return o;
};

export function go() {

  ///////////////////////////   INIZIO BONUS
  var discipline = [];
  var bonusrows = [];

  var bonusrow =
    {
    bonus : 500,
    filtro : 1,
    min_avv : 5,
    sistema : 5
    };
  bonusrows.push(bonusrow);
  var bonusrow =
    {
    bonus : 500,
    filtro : 1,
    min_avv : 5,
    sistema : 6
    };
  bonusrows.push(bonusrow);
  var bonusrow =
    {
    bonus : 500,
    filtro : 1,
    min_avv : 5,
    sistema : 7
    };
  bonusrows.push(bonusrow);
  var bonusrow =
    {
    bonus : 500,
    filtro : 1,
    min_avv : 5,
    sistema : 8
    };
  bonusrows.push(bonusrow);
  var bonusrow =
    {
    bonus : 500,
    filtro : 1,
    min_avv : 5,
    sistema : 9
    };
  bonusrows.push(bonusrow);
  var bonusrow =
    {
    bonus : 500,
    filtro : 1,
    min_avv : 5,
    sistema : 10
    };
  bonusrows.push(bonusrow);
  var bonusrow =
    {
    bonus : 500,
    filtro : 1,
    min_avv : 5,
    sistema : 11
    };
  bonusrows.push(bonusrow);
  var bonusrow =
    {
    bonus : 500,
    filtro : 1,
    min_avv : 5,
    sistema : 12
    };
  bonusrows.push(bonusrow);
  var bonusrow =
    {
    bonus : 500,
    filtro : 1,
    min_avv : 5,
    sistema : 13
    };
  bonusrows.push(bonusrow);
  var bonusrow =
    {
    bonus : 500,
    filtro : 1,
    min_avv : 5,
    sistema : 14
    };
  bonusrows.push(bonusrow);
  var bonusrow =
    {
    bonus : 500,
    filtro : 1,
    min_avv : 5,
    sistema : 15
    };
  bonusrows.push(bonusrow);
  var bonusrow =
    {
    bonus : 500,
    filtro : 1,
    min_avv : 5,
    sistema : 16
    };
  bonusrows.push(bonusrow);
  var bonusrow =
    {
    bonus : 500,
    filtro : 1,
    min_avv : 5,
    sistema : 17
    };
  bonusrows.push(bonusrow);
  var bonusrow =
    {
    bonus : 500,
    filtro : 1,
    min_avv : 5,
    sistema : 18
    };
  bonusrows.push(bonusrow);
  var bonusrow =
    {
    bonus : 500,
    filtro : 1,
    min_avv : 5,
    sistema : 19
    };
  bonusrows.push(bonusrow);
  var bonusrow =
    {
    bonus : 500,
    filtro : 1,
    min_avv : 5,
    sistema : 20
    };
  bonusrows.push(bonusrow);

  _bonusSystem = new Object();
  _bonusSystem.bonusrows = bonusrows;
  _bonusSystem.discipline = discipline;
  _bonusSystem.soglia_quota = 125;
  _bonusSystem.tipobonus = 4;
  ///////////////////////////   FINE BONUS

  ///////////////////////////   INIZIO CREAZIONE STRUTTURA
  var arrset = [];
  var testpattern = 4;
  switch (testpattern) {
  case 0:
    arrset.push("4|89557|5|1|128|3|0|esito finale 1x2|Vfb Eichstatt - Spvgg Ansbach|1|19872|4200|3|false|0|1|30/07/2016_17:00|calcio|M|1|0");
    arrset.push("4|89562|5|1|259|3|0|esito finale 1x2|Sand - Ammerthal|1|19872|4205|3|false|0|1|30/07/2016_17:00|calcio|M|1|0");
    arrset.push("4|90478|5|1|336|3|0|esito finale 1x2|Jahn Regensburg II - Kottern|1|19872|4920|3|false|0|1|31/07/2016_15:00|calcio|M|1|0");
    arrset.push("4|89556|5|1|181|3|0|esito finale 1x2|Amberg - Sv Erlenbach/main|1|19872|4199|3|false|0|1|31/07/2016_16:00|calcio|M|1|0");
    arrset.push("4|90479|5|1|227|3|0|esito finale 1x2|Fc Pipinsried - Tsv Landsberg|1|19872|4921|3|false|0|1|31/07/2016_16:00|calcio|M|1|0");

    break;
  case 1:
    /*    
        1 (15)  
        2 (100) 
        3 (392) 
        4 (1006)  
        5 (1778)  
        7 (1940)  
        8 (1177)  
        9 (471) 
        10 (112)  
        11 (12)

    SISTEMI GIOCATI
    "1|25|15|0"
    "2|25|100|0"
    "3|25|392|0"
    "4|25|1006|0"
    "5|25|1778|1"
    "7|25|1940|1"
    "8|25|1177|1"
    "9|25|471|1"
    "10|25|112|1"
    "11|25|12|1"    
    */

    arrset.push("48|92946|5|1|204|3|0|esito finale 1x2|Casertana - Tuttocuoio 1957|1|19872|8842|3|false|0|1|31/07/2016_15:00|calcio|M|1|0");
    arrset.push("48|92946|5|2|314|3|0|esito finale 1x2|Casertana - Tuttocuoio 1957|X|19872|8842|3|false|0|1|31/07/2016_15:00|calcio|M|1|0");
    arrset.push("48|92942|5|1|182|3|0|esito finale 1x2|Alessandria - Teramo|1|19872|8838|3|false|0|1|31/07/2016_17:00|calcio|M|1|0");
    arrset.push("48|92947|5|1|138|3|0|esito finale 1x2|Como - Valdinievole Montecatini|1|19872|8843|3|false|0|1|31/07/2016_17:30|calcio|M|1|0");
    arrset.push("48|92952|5|1|122|3|0|esito finale 1x2|Padova - Seregno|1|19872|8848|3|false|0|1|31/07/2016_18:00|calcio|M|0|0");
    arrset.push("48|92954|5|1|129|3|0|esito finale 1x2|Modena - Francavilla|1|19872|8850|3|false|0|1|31/07/2016_18:00|calcio|M|1|0");
    arrset.push("48|92943|5|1|270|3|0|esito finale 1x2|Ancona - Sudtirol|1|19872|8839|3|false|0|1|31/07/2016_18:30|calcio|M|1|0");
    arrset.push("48|92944|5|1|191|3|0|esito finale 1x2|Bassano - Fidelis Andria|1|19872|8840|3|false|0|1|31/07/2016_20:00|calcio|M|1|0");
    arrset.push("48|92948|5|1|124|3|0|esito finale 1x2|Cremonese - Fermana|1|19872|8844|3|false|0|1|31/07/2016_20:30|calcio|M|0|0");
    arrset.push("48|92949|5|1|154|3|0|esito finale 1x2|Foggia - Pontedera|1|19872|8845|3|false|0|1|31/07/2016_20:30|calcio|M|1|0");
    arrset.push("48|92964|5|1|113|3|0|esito finale 1x2|Matera - Caronnese|1|19872|8885|3|false|0|1|31/07/2016_20:30|calcio|M|0|0");
    arrset.push("48|92967|5|1|119|3|0|esito finale 1x2|Cosenza - Frattese|1|19872|8893|3|false|0|1|31/07/2016_20:30|calcio|M|0|0");
    arrset.push("48|92946|5|3|331|3|0|esito finale 1x2|Casertana - Tuttocuoio 1957|2|19872|8842|3|false|0|1|31/07/2016_15:00|calcio|M|1|0");
    arrset.push("48|92947|5|3|702|3|0|esito finale 1x2|Como - Valdinievole Montecatini|2|19872|8843|3|false|0|1|31/07/2016_17:30|calcio|M|1|0");
    arrset.push("48|92954|5|3|896|3|0|esito finale 1x2|Modena - Francavilla|2|19872|8850|3|false|0|1|31/07/2016_18:00|calcio|M|1|0");

    break;
  case 2:
    /*
    basi e varianti
    3 (6) 
    4 (54)  
    5 (210) 
    6 (462) 
    7 (630) 
    8 (546) 
    9 (294) 
    10 (90) 
    11 (12)
      */
    /*
    sistemi giocati
    "3|25|6|0"
    "4|25|54|0"
    "5|25|210|1"
    "6|25|462|1"
    "7|25|630|1"
    "8|25|546|1"
    "9|25|294|1"
    "10|25|90|1"
    "11|25|12|1"
     */

    arrset.push("48|92946|5|1|204|3|0|esito finale 1x2|Casertana - Tuttocuoio 1957|1|19872|8842|3|false|0|1|31/07/2016_15:00|calcio|M|1|1");
    arrset.push("48|92946|5|2|314|3|0|esito finale 1x2|Casertana - Tuttocuoio 1957|X|19872|8842|3|false|0|1|31/07/2016_15:00|calcio|M|1|1");
    arrset.push("48|92942|5|1|182|3|0|esito finale 1x2|Alessandria - Teramo|1|19872|8838|3|false|0|1|31/07/2016_17:00|calcio|M|1|0");
    arrset.push("48|92947|5|1|138|3|0|esito finale 1x2|Como - Valdinievole Montecatini|1|19872|8843|3|false|0|1|31/07/2016_17:30|calcio|M|1|1");
    arrset.push("48|92952|5|1|122|3|0|esito finale 1x2|Padova - Seregno|1|19872|8848|3|false|0|1|31/07/2016_18:00|calcio|M|0|0");
    arrset.push("48|92954|5|1|129|3|0|esito finale 1x2|Modena - Francavilla|1|19872|8850|3|false|0|1|31/07/2016_18:00|calcio|M|1|0");
    arrset.push("48|92943|5|1|270|3|0|esito finale 1x2|Ancona - Sudtirol|1|19872|8839|3|false|0|1|31/07/2016_18:30|calcio|M|1|1");
    arrset.push("48|92944|5|1|191|3|0|esito finale 1x2|Bassano - Fidelis Andria|1|19872|8840|3|false|0|1|31/07/2016_20:00|calcio|M|1|0");
    arrset.push("48|92948|5|1|124|3|0|esito finale 1x2|Cremonese - Fermana|1|19872|8844|3|false|0|1|31/07/2016_20:30|calcio|M|0|0");
    arrset.push("48|92949|5|1|154|3|0|esito finale 1x2|Foggia - Pontedera|1|19872|8845|3|false|0|1|31/07/2016_20:30|calcio|M|1|0");
    arrset.push("48|92964|5|1|113|3|0|esito finale 1x2|Matera - Caronnese|1|19872|8885|3|false|0|1|31/07/2016_20:30|calcio|M|0|0");
    arrset.push("48|92967|5|1|119|3|0|esito finale 1x2|Cosenza - Frattese|1|19872|8893|3|false|0|1|31/07/2016_20:30|calcio|M|0|0");
    arrset.push("48|92946|5|3|331|3|0|esito finale 1x2|Casertana - Tuttocuoio 1957|2|19872|8842|3|false|0|1|31/07/2016_15:00|calcio|M|1|1");
    arrset.push("48|92947|5|3|702|3|0|esito finale 1x2|Como - Valdinievole Montecatini|2|19872|8843|3|false|0|1|31/07/2016_17:30|calcio|M|1|1");
    arrset.push("48|92954|5|3|896|3|0|esito finale 1x2|Modena - Francavilla|2|19872|8850|3|false|0|1|31/07/2016_18:00|calcio|M|1|0");

    break;
  case 3:
    /*
    basi e varianti
    1 (26) 
    2 (316)  
    18 (192)
      */
    /*
    sistemi giocati
    "2|5|316|1"
    "18|5|192|0"
    */

    arrset.push("9|26911|17|1|118|1|0;0|doppia chance in|SAN PAOLO - BOTAFOGO|1X|26321|2437|15|false|0;0|1|14/08/2016_21:15|calcio|A|1|0");
    arrset.push("9|26910|19|2|123|1|0;0|doppia chance in/out|FLUMINENSE - AMERICA MINEIRO MG|12|26321|2436|17|false|0;0|1|14/08/2016_16:00|calcio|A|1|0");
    arrset.push("9|26910|17|1|108|1|0;0|doppia chance in|FLUMINENSE - AMERICA MINEIRO MG|1X|26321|2436|15|false|0;0|1|14/08/2016_16:00|calcio|A|1|0");
    arrset.push("9|26909|17|1|123|1|0;0|doppia chance in|VITORIA - SANTA CRUZ PE|1X|26321|2435|15|false|0;0|1|14/08/2016_21:00|calcio|A|1|0");
    arrset.push("206|27157|17|1|111|1|0;0|doppia chance in|BEROE STARA ZAGORA - VEREYA|1X|26321|2639|15|false|0;0|1|13/08/2016_18:00|calcio|A|1|0");
    arrset.push("206|27156|17|1|131|1|0;0|doppia chance in|FC DUNAV RUSE - PIRIN BLAGOEVGRAD|1X|26321|2638|15|false|0;0|1|12/08/2016_20:15|calcio|A|1|0");
    arrset.push("206|27155|17|1|151|1|0;0|doppia chance in|PFC MONTANA 1921 - LOKOMOTIV 1926 PLOVDIV|1X|26321|2637|15|false|0;0|1|12/08/2016_18:00|calcio|A|1|0");
    arrset.push("246|26692|19|2|124|1|0;0|doppia chance in/out|CHANGCHUN YATAI - JIANGSU FC|12|26321|2248|17|false|0;0|1|14/08/2016_13:35|calcio|A|1|0");
    arrset.push("246|26687|19|2|122|1|0;0|doppia chance in/out|YANBIAN FUNDE - SHANGHAI SIPG|12|26321|2243|17|false|0;0|1|13/08/2016_09:30|calcio|A|1|0");
    arrset.push("9|36184|17|1|114|1|0;0|doppia chance in|CRUZEIRO - CORITIBA|1X|26321|7083|15|false|0;0|1|14/08/2016_21:00|calcio|A|1|0");
    arrset.push("206|27188|17|1|139|1|0;0|doppia chance in|PFK BOTEV PLOVDIV - SLAVIA SOFIA|1X|26331|1044|15|false|0;0|1|15/08/2016_19:00|calcio|A|1|0");
    arrset.push("9|26916|19|2|127|1|0;0|doppia chance in/out|PONTE PRETA SP - FIGUEIRENSE|12|26321|2442|17|false|0;0|1|13/08/2016_23:30|calcio|A|1|0");
    arrset.push("9|26916|17|1|118|1|0;0|doppia chance in|PONTE PRETA SP - FIGUEIRENSE|1X|26321|2442|15|false|0;0|1|13/08/2016_23:30|calcio|A|1|0");
    arrset.push("9|26915|17|1|129|1|0;0|doppia chance in|CHAPECOENSE SC - INTERNACIONAL PORTO ALEGRE|1X|26321|2441|15|false|0;0|1|16/08/2016_01:00|calcio|A|1|0");
    arrset.push("9|26914|17|1|120|1|0;0|doppia chance in|GREMIO - CORINTHIANS|1X|26321|2440|15|false|0;0|1|14/08/2016_16:00|calcio|A|1|0");
    arrset.push("246|26464|19|2|117|1|0;0|doppia chance in/out|BEIJING GUOAN FC - CHONGQING LIFAN|12|26321|1374|17|false|0;0|1|12/08/2016_13:35|calcio|A|1|0");
    arrset.push("246|26693|17|1|118|1|0;0|doppia chance in|HEBEI CHINA FORTUNE FC - LIAONING WHOWIN FC|1X|26321|2249|15|false|0;0|1|14/08/2016_13:35|calcio|A|1|0");
    arrset.push("246|26692|18|2|120|1|0;0|doppia chance out|CHANGCHUN YATAI - JIANGSU FC|X2|26321|2248|16|false|0;0|1|14/08/2016_13:35|calcio|A|1|0");
    arrset.push("246|26692|17|1|170|1|0;0|doppia chance in|CHANGCHUN YATAI - JIANGSU FC|1X|26321|2248|15|false|0;0|1|14/08/2016_13:35|calcio|A|1|0");
    arrset.push("246|26690|19|2|127|1|0;0|doppia chance in/out|SHIJIAZHUANG EVER BRIGHT FC - TIANJIN TEDA|12|26321|2246|17|false|0;0|1|13/08/2016_13:35|calcio|A|1|0");
    arrset.push("246|26690|17|1|132|1|0;0|doppia chance in|SHIJIAZHUANG EVER BRIGHT FC - TIANJIN TEDA|1X|26321|2246|15|false|0;0|1|13/08/2016_13:35|calcio|A|1|0");
    arrset.push("246|26689|19|2|123|1|0;0|doppia chance in/out|SHANGHAI SHENHUA - GUANGZHOU EVERGRANDE|12|26321|2245|17|false|0;0|1|13/08/2016_13:35|calcio|A|1|0");
    arrset.push("246|26689|17|1|160|1|0;0|doppia chance in|SHANGHAI SHENHUA - GUANGZHOU EVERGRANDE|1X|26321|2245|15|false|0;0|1|13/08/2016_13:35|calcio|A|1|0");
    arrset.push("246|26688|19|2|128|1|0;0|doppia chance in/out|HANGZHOU GREENTOWN FC - HENAN JIANYE|12|26321|2244|17|false|0;0|1|13/08/2016_13:35|calcio|A|1|0");
    arrset.push("246|26688|17|1|139|1|0;0|doppia chance in|HANGZHOU GREENTOWN FC - HENAN JIANYE|1X|26321|2244|15|false|0;0|1|13/08/2016_13:35|calcio|A|1|0");
    arrset.push("246|26687|18|2|122|1|0;0|doppia chance out|YANBIAN FUNDE - SHANGHAI SIPG|X2|26321|2243|16|false|0;0|1|13/08/2016_09:30|calcio|A|1|0");

    break;
  case 4:
    /*
     * combinazioni
    2 (6)  
    0.25
    vincita potenziale MIN : 0,53 euro
    vincita potenziale MAX : 11,69 euro

    3 (42)  
    0.25
    vincita potenziale MIN : 0,98 euro
    vincita potenziale MAX : 47,56 euro

    4 (120) 
    0.25
    vincita potenziale MIN : 2,24 euro
    vincita potenziale MAX : 176,92 euro

    5 (180) 
    0.25
    vincita potenziale MIN : 6,88 euro
    vincita potenziale MAX : 575,88 euro

    6 (150) 
    0.25
    vincita potenziale MIN : 22,31 euro
    vincita potenziale MAX : 1868,44 euro

    7 (66)  
    0.25
    vincita potenziale MIN : 87,16 euro
    vincita potenziale MAX : 4473,04 euro

    8 (12)  
    0.25
    vincita potenziale MIN : 645,20 euro
    vincita potenziale MAX : 8641,92 euro
    */
    // basi varianti
    /*
     * sistemi giocati
    "2|25|6|0"
    "3|25|42|0"
    "4|25|120|0"
    "5|25|180|1"
    "6|25|150|1"
    "7|25|66|1"
    "8|25|12|1"
     */
    arrset.push("22|109204|5|1|145|3|0;0|esito finale 1x2|As Roma - Udinese Calcio|1|26333|2538|3|false|0;0|1|20/08/2016_18:00|calcio|M|1|1");
    arrset.push("22|109204|5|2|434|3|0;0|esito finale 1x2|As Roma - Udinese Calcio|X|26333|2538|3|false|0;0|1|20/08/2016_18:00|calcio|M|1|1");
    arrset.push("22|109204|5|3|663|3|0;0|esito finale 1x2|As Roma - Udinese Calcio|2|26333|2538|3|false|0;0|1|20/08/2016_18:00|calcio|M|1|1");
    arrset.push("22|109205|5|1|147|3|0;0|esito finale 1x2|Juventus Turin - Acf Fiorentina|1|26333|2542|3|false|0;0|1|20/08/2016_20:45|calcio|M|1|0");
    arrset.push("22|109205|5|2|407|3|0;0|esito finale 1x2|Juventus Turin - Acf Fiorentina|X|26333|2542|3|false|0;0|1|20/08/2016_20:45|calcio|M|1|0");
    arrset.push("22|110646|5|1|309|3|0;0|esito finale 1x2|Atalanta Bergamasca Calcio - Ss Lazio Roma|1|26333|12643|3|false|0;0|1|21/08/2016_20:45|calcio|M|1|0");
    arrset.push("22|110647|5|1|184|3|0;0|esito finale 1x2|Bologna Fc - Fc Crotone|1|26333|12644|3|false|0;0|1|21/08/2016_20:45|calcio|M|1|0");
    arrset.push("22|110648|5|1|372|3|0;0|esito finale 1x2|Ac Chievo Verona - Inter Milano|1|26333|12645|3|false|0;0|1|21/08/2016_20:45|calcio|M|1|0");
    arrset.push("22|110649|5|1|228|3|0;0|esito finale 1x2|Empoli - Sampdoria|1|26333|12646|3|false|0;0|1|21/08/2016_20:45|calcio|M|1|0");
    arrset.push("22|110651|5|1|705|3|0;0|esito finale 1x2|Pescara - Napoli|1|26333|12648|3|false|0;0|1|21/08/2016_20:45|calcio|M|1|0");
    arrset.push("22|111278|5|1|293|3|0;0|esito finale 1x2|Palermo - Sassuolo|1|26341|5148|3|false|0;0|1|21/08/2016_20:45|calcio|M|1|1");
    arrset.push("22|111278|5|2|310|3|0;0|esito finale 1x2|Palermo - Sassuolo|X|26341|5148|3|false|0;0|1|21/08/2016_20:45|calcio|M|1|1");
    break;
  default:
    break;
  }

  fixedArray = [];
  var set = [];
  for (var i = 0; i < arrset.length; i++) {
    var datiacc = arrset[i];
    var o = spacchettaAccSys(datiacc);
    set.push(o);
    if (o.fissa == 1) {
      fixedArray.push(o);
    }
  }
  ///////////////////////////   FINE CREAZIONE STRUTTURA
  //event equivale agli avvenimenti

  /// init global

  validCombination = new Array(30);
  for (var ff = 0; ff < validCombination.length; ff++) {
    if (ff > 30)
      validCombination[ff] = 0;
    else
      validCombination[ff] = 1;
  }

  syspartecipabonus = new Array(31);
  for (var i = 0; i < syspartecipabonus.length; i++) {
    syspartecipabonus[i] = false;
  }
  for (var i = 0; i < v_vin_pot_max.length; i++) {
    v_vin_pot_max[i] = 0.0;
  }

  for (var i = 0; i < importicomb.length; i++) {
    importicomb[i] = 0.0;
  }

  for (var i = 0; i < maxSystemWinning.length; i++) {
    maxSystemWinning[i] = 0;
  }

  nr_mult_con_nr_flag_bonus_sup_min_avv = 0;
  nr_mult_tutti_flag_bonus_on = 0;
  max_nAvvValidi = 0;

  // fine init global

  var fx = calcNeventBasi(set);

  _systemCombinations = getAllCombinations(set, fx, fixedArray);
  _systemCombinationsCount = countCombination;

  var nEvent = calcNevent(set);

  //// crea oggetto di ritorno
  rissys = new Object();
  rissys.syspartecipabonus = new Array(31);
  rissys.v_min = new Array(31);
  rissys.v_max = new Array(31);
  rissys.comb = new Array(31);
  rissys.importi = new Array(31);
  rissys.v_vin_pot_max = new Array(31);
  rissys.nr_mult_con_nr_flag_bonus_sup_min_avv = 0;
  rissys.nr_mult_tutti_flag_bonus_on = 0;
  rissys.max_nAvvValidi = 0;
  rissys.maxSystemWinning = new Array(31);

  for (let xx = 0; xx < rissys.syspartecipabonus.length; xx++) {
    rissys.syspartecipabonus[xx] = false;
    rissys.v_min[xx] = 0.0;
    rissys.v_max[xx] = 0.0;
    rissys.comb[xx] = 0;
    rissys.importi[xx] = 0.0;
    rissys.v_vin_pot_max[xx] = 0;
  }

  for (let xx = 1; xx <= nEvent; xx++) {
    computeSystem(xx);
  }

  for (let i = 0; i < v_vin_pot_max.length; i++) {
    rissys.v_vin_pot_max[i] = v_vin_pot_max[i];
  }

  for (let i = 0; i < importicomb.length; i++) {
    rissys.importi[i] = importicomb[i];
  }

  for (var i = 0; i < rissys.maxSystemWinning.length; i++) {
    rissys.maxSystemWinning[i] = maxSystemWinning[i];
  }

  rissys.nr_mult_con_nr_flag_bonus_sup_min_avv = nr_mult_con_nr_flag_bonus_sup_min_avv;
  rissys.nr_mult_tutti_flag_bonus_on = nr_mult_tutti_flag_bonus_on;
  rissys.max_nAvvValidi = max_nAvvValidi;

}
// funzione per il calcolo dei sistemi
export function calculateSysData(arrset, bonusSys) {
  /// init global
  _bonusSystem = bonusSys;

  fixedArray = [];
  var set = [];
  for (var i = 0; i < arrset.length; i++) {
    var datiacc = arrset[i];
    var o = spacchettaAccSys(datiacc);
    set.push(o);
    if (o.fissa == 1) {
      fixedArray.push(o);
    }
  }

  validCombination = new Array(30);
  for (var ff = 0; ff < validCombination.length; ff++) {
    if (ff > 30)
      validCombination[ff] = 0;
    else
      validCombination[ff] = 1;
  }

  syspartecipabonus = new Array(31);
  for (var i = 0; i < syspartecipabonus.length; i++) {
    syspartecipabonus[i] = false;
  }
  for (var i = 0; i < v_vin_pot_max.length; i++) {
    v_vin_pot_max[i] = 0.0;
  }

  for (var i = 0; i < v_maxpotbonus.length; i++) {
    v_maxpotbonus[i] = 0.0;
  }

  for (var i = 0; i < v_minpotbonus.length; i++) {
    v_minpotbonus[i] = 0.0;
  }

  for (var i = 0; i < importicomb.length; i++) {
    importicomb[i] = 0.0;
  }
  nr_mult_con_nr_flag_bonus_sup_min_avv = 0;
  nr_mult_tutti_flag_bonus_on = 0;
  max_nAvvValidi = 0;

  for (var i = 0; i < maxSystemWinning.length; i++) {
    maxSystemWinning[i] = 0;
  }

  // fine init global

  var fx = calcNeventBasi(set);

  calcIncludedMaxWinningSystem(set);

  _systemCombinations = getAllCombinations(set, fx, fixedArray);
  _systemCombinationsCount = countCombination;

  var nEvent = calcNevent(set);

  //// crea oggetto di ritorno
  rissys = new Object();
  rissys.righe_basi_varianti = [];
  rissys.syspartecipabonus = new Array(31);
  rissys.v_min = new Array(31);
  rissys.v_max = new Array(31);
  rissys.comb = new Array(31);
  rissys.importi = new Array(31);
  rissys.v_vin_pot_max = new Array(31);
  rissys.v_maxpotbonus = new Array(31);
  rissys.v_minpotbonus = new Array(31);
  rissys.nr_mult_con_nr_flag_bonus_sup_min_avv = 0;
  rissys.nr_mult_tutti_flag_bonus_on = 0;
  rissys.max_nAvvValidi = 0;
  rissys.maxSystemWinning = new Array(31);

  for (let xx = 0; xx < rissys.syspartecipabonus.length; xx++) {
    rissys.syspartecipabonus[xx] = false;
    rissys.v_min[xx] = 0.0;
    rissys.v_max[xx] = 0.0;
    rissys.comb[xx] = 0;
    rissys.importi[xx] = 0.0;
    rissys.v_vin_pot_max[xx] = 0;
    rissys.v_maxpotbonus[xx] = 0;
    rissys.v_minpotbonus[xx] = 0;
  }

  for (let xx = 1; xx <= nEvent; xx++) {
    computeSystem(xx);
  }

  for (let i = 0; i < v_vin_pot_max.length; i++) {
    rissys.v_vin_pot_max[i] = v_vin_pot_max[i];
    rissys.v_maxpotbonus[i] = v_maxpotbonus[i];
    rissys.v_minpotbonus[i] = v_minpotbonus[i];
  }
  for (let i = 0; i < importicomb.length; i++) {
    rissys.importi[i] = importicomb[i];
  }
  rissys.nr_mult_con_nr_flag_bonus_sup_min_avv = nr_mult_con_nr_flag_bonus_sup_min_avv;
  rissys.nr_mult_tutti_flag_bonus_on = nr_mult_tutti_flag_bonus_on;
  rissys.max_nAvvValidi = max_nAvvValidi;

  for (let i = 0; i < set.length; i++) {
    let datiacc = set[i];
    let obj = $.extend(true, {}, datiacc);
    rissys.righe_basi_varianti.push(obj);
  }

  for (let i = 0; i < rissys.maxSystemWinning.length; i++) {
    rissys.maxSystemWinning[i] = maxSystemWinning[i];
  }

  return rissys;
}

export function calculateOddsForSingleCombinations(odds, combs, countComb, k) {

  //a questo punto devo calcolare esattamente tutte le combinazioni, se non è stato già fatto
  if (FinalcalculateComb[k].length == 0) {

    var precalc = PrecalculateComb[k];

    //per ogni combinazione precalcolata
    for (var pp = 0; pp < precalc.length; pp++) {

      //verifico se la combinazioni va ulteriormente sviluppata, oppure la posso utilizzare così com'è
      //se il prodotto delle combinazioni è 1 allor ci troviamo di fronte ad una singola combinazione
      if (SingleCombCount[k][pp] == 1) {

        //calcolo gli indici dell'array Ctemp da utilizzare come base per inserire l'elemento corretto
        var combination = [];

        //l'indice di base va preso in base ovviamente alla combinazione precalcolata
        for (var ij = 0; ij < k; ij++) {
          combination.push(EV[precalc[pp][ij]][0]);
        }

        FinalcalculateComb[k].push(combination);
      } else {

        //algoritmo 
        //indice di base per costruire le combinazioni

        var CtempIndex = [];
        for (var i = 0; i < k; i++)
          CtempIndex[i] = 0;

        //prima di cominciare inserisco la prima combinazione
        //inserisco la combinazione utilizzando gli indici CtempIndex
        //prima combin CtempIndex = [0, 0, 0, 0, 0, 0, 0, 0, 0];
        //prima combinazione C(0) = [A1, B1, C1, D, E, F, G, H, I];

        for (var i = 0; i < SingleCombCount[k][pp]; i++) {

          //calcolo gli indici dell'array Ctemp da utilizzare come base per inserire l'elemento corretto
          var combination = [];

          //l'indice di base va preso in base ovviamente alla combinazione precalcolata
          for (var ij = 0; ij < k; ij++) {
            combination.push(EV[precalc[pp][ij]][CtempIndex[ij]]);
          }

          FinalcalculateComb[k].push(combination);

          for (var j = k - 1; j >= 0; j--) {
            //verifico quale indice posso incrementare partendo dall'ultimo che abbia lunghezza superiore a 1;
            if (CtempIndex[j] + 1 < EV[precalc[pp][j]].length) {
              CtempIndex[j] += 1;
              break;
            }
          }

          //una volta individuato l'indice j dell'array CtempIndex, tutte le successive devono variare
          for (var t = j + 1; t < k; t++) {

            //non serve variare tutti poichè quando hanno un solo esito devono restare fissi 
            if (EV[precalc[pp][t]].length == 1)
              break;
            //CtempIndex[t] = (CtempIndex[t] + 1) % (EV[precalc[pp][t]].length - 1)
            CtempIndex[t] = (CtempIndex[t] + 1) % (EV[precalc[pp][t]].length)
          }
        }
      }
    }
  }

  //quì di sicuro ho calcolato le combinazioni adesso verifico le quote
  if (OddsComb[k].length == 0) {

    //calcolo le quote delle varie combinazioni in k
    for (var cc = 0; cc < FinalcalculateComb[k].length; cc++) {

      //prendo la prima combinazione
      var partialOdds = 1;

      var validCombForWinning = 1;
      for (var ff = 0; ff < FinalcalculateComb[k][cc].length; ff++) {

        partialOdds *= parseFloat(FinalcalculateComb[k][cc][ff].odd) * 1.000000000000001;

        //verifico se la combinazione deve far parte del calcolo della vincita potenziale
        //se l'elemento in posizione 6 è 0, l'esito deve essere escluso dal calcolo della vincita totale massima potenziale
        if (validCombForWinning) {

          if (FinalcalculateComb[k][cc][ff].includeForMaxWinningSystem == 0) {
            validCombForWinning = 0;
          }

        }
      }

      OddsCombForWinning[k][cc] = validCombForWinning;
      var appo = truncateDecimal(partialOdds, 6);
      OddsComb[k][cc] = appo;
      //OddsComb[k][cc] = partialOdds;
    }
  }

  return OddsComb;
}

export function checkDisciplinaSys(disc, discipline) {
  var res = true;
  var l = discipline.length;
  for (var i = 0; i < l; i++) {
    var disciplina = discipline[i];
    if (disciplina == disc) {
      res = false;
      break;
    }
  }
  return res;
};

export function CalculateGenericBonus(eventArray, bonusInfo, amount, s) {

  //quota soglia
  var minQuota = bonusInfo.soglia_quota;

  var discipline = bonusInfo.discipline;
  var tipobonus = bonusInfo.tipobonus

  var nAvvValidi = 0;
  var nAvvEsclusi = 0;
  var bonusOdd = 1;
  var totalOdds = 1;
  // ciclo su tutti i miei eventi e verifico quelli che rispettano la quota soglia e 
  // se appartengono a discipline non valide per il calcolo del bonus
  var num_avv = eventArray.length;
  for (var ii = 0; ii < num_avv; ii++) {
    var ev = eventArray[ii];
    var quota = ev.odd;
    var quotaint = ev.quota;
    var disc = parseInt(ev.disciplina, 10);

    totalOdds *= (quota * 1.000000000000001);

    if ((quotaint >= minQuota) && checkDisciplinaSys(disc, discipline)) {
      bonusOdd = bonusOdd * quota;
      nAvvValidi++;
      ev.partecipabonus = true;
    } else {
      nAvvEsclusi++;
    }
  }

  //trovo il bonus
  var br = null;
  var br_vett = bonusInfo.bonusrows;
  if (tipobonus == 10) {
    for (var zz = 0; zz < br_vett.length; zz++) {
      var br_loc = br_vett[zz];
      if (br_loc.min_avv == nAvvValidi) {
        br = br_loc;
        break;
      }
    }
  } else {

    for (var zz = 0; zz < br_vett.length; zz++) {
      var br_loc = br_vett[zz];
      if (br_loc.sistema == s) {
        br = br_loc;
        break;
      }
    }
  }
  if (br == null)
    return 0;

  if (nAvvValidi > max_nAvvValidi) {
    max_nAvvValidi = nAvvValidi;
  }

  //rate percentuale bonus
  var bonus = br.bonus;
  var filtro = br.filtro;
  var min_avv = br.min_avv;

  var num_avv_flag_bonus_on = nAvvValidi;

  var imp_bonus = 0;
  switch (tipobonus) {
  case 0:
    // no bonus
    return 0;
    break;
  case 4:
    // Bonus percentuale
    if (filtro == 1) {
      // Bonus applicato alle multiple con almeno un esito con flag bonus = 1 
      var quota_bonus = bonus / 10000.00;
      quota_bonus += 1.0;
      var num_volte_bonus = num_avv_flag_bonus_on - min_avv + 1;
      var quota = 1.0;
      for (var m = 0; m < num_volte_bonus; m++) {
        quota = quota * quota_bonus;
      }
      imp_bonus = totalOdds * (quota - 1.0);
      if ((num_avv_flag_bonus_on > 0) && (num_avv_flag_bonus_on >= min_avv)) {
        syspartecipabonus[num_avv] = true;
      }
      if (num_volte_bonus > 0) {
        nr_mult_con_nr_flag_bonus_sup_min_avv++;
      }
    } else {
      // Bonus applicato alle multiple con tutti gli esiti con flag bonus = 1
      if (num_avv == num_avv_flag_bonus_on) {
        var quota_bonus = bonus / 10000.00;
        quota_bonus += 1.0;
        var num_volte_bonus = num_avv_flag_bonus_on - min_avv + 1;
        var quota = 1.0;
        for (var m = 0; m < num_volte_bonus; m++) {
          quota = quota * quota_bonus;
        }
        imp_bonus = totalOdds * (quota - 1.0);
        syspartecipabonus[num_avv] = true;

        nr_mult_tutti_flag_bonus_on++;
      } else {
        imp_bonus = 0;
      }
    }

    return imp_bonus;

    break;
  case 5:
    // Bonus importo
    if (num_avv == num_avv_flag_bonus_on) {
      imp_bonus = bonus;
      syspartecipabonus[num_avv] = true;
    }
    return imp_bonus;
    break;
  case 7:
    // Bonus importo variabile
    if (num_avv == num_avv_flag_bonus_on) {
      imp_bonus = bonus;
      syspartecipabonus[num_avv] = true;
      nr_mult_tutti_flag_bonus_on++;
    }
    return imp_bonus;
    break;

  case 10:
    //Bonus Fasce Sistemi

    // Bonus applicato alle multiple con tutti gli esiti con flag bonus = 1
    //if (num_avv == num_avv_flag_bonus_on) {
      var quota_bonus = bonus / 10000.00;
      quota_bonus += 1.0;
    //var num_volte_bonus = num_avv_flag_bonus_on - min_avv + 1;
      var quota = 1.0;
    //for (var m = 0; m < num_volte_bonus; m++) {
        quota = quota * quota_bonus;
    //}
      imp_bonus = totalOdds * (quota - 1.0);
      syspartecipabonus[num_avv] = true;

      nr_mult_tutti_flag_bonus_on++;
    //    } else {
    //      imp_bonus = 0;
    //    }
    return imp_bonus;
    break;

  default:
    break;
  }
  return 0;
}

export function calculateBonusSystem(combs, countComb, s) {

  var bonusInfoInternal;
  var odds = [];
  var bonusNetti = [];

  bonusInfoInternal = _bonusSystem;

  for (var i = 0; i < FinalcalculateComb[s].length; i++) {

    let betInput = 0.01; //default un centesimo

    var bonus = CalculateGenericBonus(FinalcalculateComb[s][i], bonusInfoInternal, parseFloat(betInput), s);
    odds.push(bonus);

    var bonusNetto = bonus > 0 ? bonus - betInput : bonus;
    bonusNetti.push(bonusNetto);

  }
  var obj = new Object();
  obj.odds = odds;
  obj.bonusNetti = bonusNetti;
  return obj;

}

export function computeSystem(s) {
  if (_systemCombinationsCount[s] > 0 && _systemCombinationsCount[s] <= 2000) {

    _systemCombinationsOdds = new Array(31);
    _systemCombinationsBonus = new Array(31);
    _systemCombinationsBonusNetti = new Array(31);

    for (var z = 0; z < 31; z++) {
      _systemCombinationsOdds[z] = 0;
      _systemCombinationsBonus[z] = 0;
      _systemCombinationsBonusNetti[z] = 0;
    }

    _systemArray = [];

    winningAmount = 0;

    var currentVal = 1;

    _systemCombinationsOdds = calculateOddsForSingleCombinations(_systemCombinationsOdds, _systemCombinations, _systemCombinationsCount, s);

    var objBonus = calculateBonusSystem(_systemCombinations, _systemCombinationsCount, s);

    _systemCombinationsBonus[s] = objBonus.odds;
    _systemCombinationsBonusNetti[s] = objBonus.bonusNetti;

    //verifico la quota maggiore
    winningAmount = 0;
    minWinningAmount = 0;

    var bonusMinimoTmp = 0;
    var bonusMassimoTmp = 0;
    var bonusTotale = 0;

    for (var so = 0; so < _systemCombinationsOdds[s].length; so++) {
      var combinationWinningTmp = parseFloat(_systemCombinationsOdds[s][so] /* * currentVal*/) + _systemCombinationsBonus[s][so];
      var bonusTmp = _systemCombinationsBonusNetti[s][so];

      v_vin_pot_max[s] += combinationWinningTmp;

      if (so == 0) {
        winningAmount = combinationWinningTmp;
        minWinningAmount = combinationWinningTmp;
        bonusMinimoTmp = bonusTmp;
        bonusMassimoTmp = bonusTmp;
      }
      importicomb[s] += combinationWinningTmp;
      if (combinationWinningTmp > winningAmount)
        winningAmount = combinationWinningTmp;
      if (combinationWinningTmp < minWinningAmount)
        minWinningAmount = combinationWinningTmp;

      if (bonusTmp > bonusMassimoTmp) {
        bonusMassimoTmp = bonusTmp;
      }
      if (bonusTmp < bonusMinimoTmp) {
        bonusMinimoTmp = bonusTmp;
      }

      bonusTotale += bonusTmp;

    }

    v_minpotbonus[s] = bonusMinimoTmp;
    v_maxpotbonus[s] = bonusMassimoTmp;

    //    console.debug("bonusMinimoTmp 	: " + bonusMinimoTmp );
    //    console.debug("bonusMassimoTmp 	: " + bonusMassimoTmp );
    //    console.debug("bonusTotale 		: " + bonusTotale );

    rissys.comb[s] = _systemCombinationsCount[s];
    //    rissys.v_min[s] = truncateDecimal(this.minWinningAmount, 2);
    //    rissys.v_max[s] = truncateDecimal(this.winningAmount, 2);

    rissys.v_min[s] = minWinningAmount;
    rissys.v_max[s] = winningAmount;

    rissys.syspartecipabonus[s] = syspartecipabonus[s];
    //    console.log('sys ' + s + " comb: " + _systemCombinationsCount[s] + " min: " + truncateDecimal(this.minWinningAmount, 2) + " max: " + truncateDecimal(this.winningAmount, 2)    + " bflag: " + syspartecipabonus[s]);

    //aggiorno il numero totale di combinazioni
    _systemCombinationsCountTotal = 0;
    _systemCombinationsTotalAmount = 0;

    //qui calcolo la vincita massima per sistema

    _maxSystemWinning = 0;
    var maxSystemWinningOdds = [];
    for (var mw = 0; mw < _systemCombinationsOdds.length; mw++) {
      if (mw == s) {
        var amount = 1; // calcoliamo a 1 centesimo

        //calcolo per 1 centesimo e controllo se effettivamente ci sono delle combinazioni sviluppate
        if (amount > 0 && _systemCombinationsOdds[mw].length > 0) {
          for (var mwi = 0; mwi < _systemCombinationsOdds[mw].length; mwi++) {
            //verifico se la combinazione sviluppata è utilizzabile per il calcolo della vincita massima

            if (OddsCombForWinning[mw][mwi] == 1) {
              var bonus = _systemCombinationsBonus[mw][mwi];
              if (isNaN(bonus)) {
                bonus = 0;
              }
              _maxSystemWinning += _systemCombinationsOdds[mw][mwi] * amount + bonus;

              var value = _systemCombinationsOdds[mw][mwi] * amount + bonus;
              maxSystemWinningOdds.push(value);

              //console.log('part _maxSystemWinning ' + _systemCombinationsOdds[mw][mwi] + bonus + ' - ' + _maxSystemWinning);
            }
          }
        }
      }
    }
    //maxSystemWinning[s] = _maxSystemWinning;
    maxSystemWinning[s] = maxSystemWinningOdds;

    console.log('tot _maxSystemWinning di ' + s + '  -  ' + _maxSystemWinning)

  }
};

export function calcNevent(set) {
  var nevent = 0;
  var h_avv = new Hashtable();
  for (var s = 0; s < set.length; s++) {
    var item = set[s];
    var eventId = item.eventId; //id avv
    h_avv.put(eventId, eventId);
  }
  nevent = h_avv.size()

  return nevent;
};

export function calcNeventBasi(set) {
  var nevent = 0;
  var h_avv = new Hashtable();
  for (var s = 0; s < set.length; s++) {
    var item = set[s];
    if (item.fissa == 1) {
      var eventId = item.eventId; //id avv
      h_avv.put(eventId, eventId);
    }
  }
  nevent = h_avv.size()

  return nevent;
};

export function calcIncludedMaxWinningSystem(set) {
  var h_avv = new Hashtable();
  for (var s = 0; s < set.length; s++) {
    var item = set[s];
    var eventId = item.eventId; //id avv
    var idScomm = item.idScomm; //id scomm
    var h_scomm = h_avv.get(eventId);

    if (h_scomm != undefined) {
      var arrscomm = h_scomm.get(idScomm);

      if (arrscomm != undefined) {
        arrscomm.push(item);
      } else {
        var arrscomm = [];
        arrscomm.push(item);
        h_scomm.put(idScomm, arrscomm);
      }
    } else {
      var h_scomm = new Hashtable();
      var arrscomm = [];
      arrscomm.push(item);
      h_scomm.put(idScomm, arrscomm);
      h_avv.put(eventId, h_scomm);
    }
  }
  var k = h_avv.keys();
  for (var j = 0; j < k.length; j++) {
    var eventId = k[j];
    var h_scomm = h_avv.get(eventId);
    var kk = h_scomm.keys();
    for (var jj = 0; jj < kk.length; jj++) {

      var idScomm = kk[jj];
      var arrscomm = h_scomm.get(idScomm);

      var idx = -1;
      var tmpOdds = -1;
      for (var z = 0; z < arrscomm.length; z++) {
        var item = arrscomm[z];
        var quota = parseInt(item.quota);
        if (quota > tmpOdds) {
          idx = z;
          tmpOdds = quota;
        }
      }

      arrscomm[idx].includeForMaxWinningSystem = 1;
    }

  }
  var aa = 0;
}

export function getAllCombinations(set, fx, fixedArray) {

  result2 = [];
  countCombination = new Array(31);
  extraQuoteCombination = new Array(31);
  //fixed
  var f = fx;

  var _nEvent = calcNevent(set);

  for (var zz = 0; zz < countCombination.length; zz++) {
    countCombination[zz] = 0;
    extraQuoteCombination[zz] = 0;
  }

  result2 = combinations(set, _nEvent, fixedArray);
  return result2;
};

export function combinations(set, eventNumber, fixedEvent) {

  var k, i, combs, k_combs;
  var e = set.length;
  var f = fixedEvent.length; ///da VERIFICARE

  //verifico se l'utente ha aggiunto o eliminato elementi
  //se li aggiunge posso sfruttare il calcolo fatto in precedenza
  //se invece li elimina devo per forza ricalcolare anche tutti gli altri
  if (oldSetLength > e || (fixedEvent.length < oldFixedevent)) {
    for (var ff = 0; ff < validCombination.length; ff++)
      validCombination[ff] = 1;
  }

  // Memorizzo il numero di esiti fissi
  oldFixedevent = fixedEvent.length;

  //verifico se ci sono delle doppie
  var classicSystem = set.length == eventNumber;

  //per prima cosa creo 3 array
  //1° contiene gli eventi ed esiti chiamato EV (per ogni posizione dell'array ci possono essere più elementi in base agli esiti selezionati)
  //2° contiene solo i numeri di esiti per ogni avvenimento chiamato ES
  //3° contiene solo l'eventuale fissa chiamato F

  EV = new Array(eventNumber);
  ES = new Array(eventNumber);
  F = new Array(eventNumber);

  IA = new Array(eventNumber);

  PrecalculateComb = new Array(eventNumber + 1);
  SingleCombCount = new Array(eventNumber + 1);
  OddsComb = new Array(eventNumber + 1);
  OddsCombForWinning = new Array(eventNumber + 1);

  for (var ix = 0; ix < EV.length; ix++) {
    EV[ix] = [];
    ES[ix] = 0;
    F[ix] = 0;
    IA[ix] = ix;
  }

  for (var ix = 0; ix < PrecalculateComb.length; ix++) {
    PrecalculateComb[ix] = [];
    SingleCombCount[ix] = [];
    FinalcalculateComb[ix] = [];
    OddsComb[ix] = [];
    OddsCombForWinning[ix] = [];
  }

  for (var s = 0; s < set.length; s++) {
    var item = set[s];
    var eventId = 0;
    //if (fastbet || livecenter)
    eventId = item.eventId; //id avv
    //else
    //  eventId = item[0];

    for (var evI = 0; evI < EV.length; evI++) {
      if (EV[evI].length == 0) {
        EV[evI].push(item);
        ES[evI] += 1;
        break;
      } else {
        if (EV[evI][0].eventId == eventId) {
          EV[evI].push(item);
          ES[evI] += 1;
          break;
        } else if (EV[evI][0][0] == eventId) {
          EV[evI].push(item);
          ES[evI] += 1;
          break;
        }
      }
    }
  }

  var fixedForEvent = 0;

  //fixed
  for (var evI = 0; evI < EV.length; evI++) {
    for (var fx = 0; fx < fixedEvent.length; fx++) {

      if (fixedEvent[fx].eventId == EV[evI][0].eventId) {
        F[evI] = 1;
        fixedForEvent++;
        break;
      }

    }
  }

  //ordino in base alle fisse - decrescente - 

  var containFixed = fixedEvent.length > 0 ? 1 : 0;

  if (containFixed == 1) {
    for (var fx = 0; fx < F.length; fx++) {
      //indice massimo
      var max = fx;
      for (var fxx = fx + 1; fxx < F.length; fxx++) {
        if (F[fxx] >= F[max])
          max = fxx;
      }

      //swap tra fx e max
      var tmpEV = EV[fx];
      var tmpES = ES[fx];
      var tmpF = F[fx];

      EV[fx] = EV[max];
      ES[fx] = ES[max];
      F[fx] = F[max];

      EV[max] = tmpEV;
      ES[max] = tmpES;
      F[max] = tmpF;
    }
  }

  //ordino in base agli esiti - decrescente - 

  for (var fx = 0; fx < ES.length; fx++) {
    //indice massimo
    var max = fx;
    for (var fxx = fx + 1; fxx < ES.length; fxx++) {
      if (ES[fxx] > ES[max] && containFixed == F[fxx])
        max = fxx;
    }

    //swap tra fx e max
    var tmpEV = EV[fx];
    var tmpES = ES[fx];
    var tmpF = F[fx];

    EV[fx] = EV[max];
    ES[fx] = ES[max];
    F[fx] = F[max];

    EV[max] = tmpEV;
    ES[max] = tmpES;
    F[max] = tmpF;
  }

  //ordino i 3 array prima in base ad F decrescente poi in base a ES decrescente

  combs = [];
  // Calculate all non-empty k-combinations
  for (k = 1; k <= eventNumber; k++) {

    if (validCombination[k] == 0)
      continue;

    //se k < numeroFisse = escludere a priori
    if (k < fixedForEvent) {
      validCombination[k] = 0;
      continue;
    }

    var nc = 1;
    //prima di calcolare le combinazioni, calcolo in numero di combinazioni

    nc = KFactorial(eventNumber - f) / (KFactorial(k - f) * KFactorial(eventNumber - k));

    //limite massimo di colonne scommettibili
    if (nc > 2000) {
      validCombination[k] = 0;
      continue;
    }

    //approccio lazy
    var cmb, a, ct = 0, internalValid = true;

    cmb = Combinatorics.combination(IA, k);

    var tmpArray = [];
    while (a = cmb.next()) {

      //tutte le combinazioni calcolate quì sono valide
      //devo solo verificare se contiene come primo elemento una fissa

      //al momento le combinazioni non sono ordinate, quindi devo per forza di cose controllare tutte le combinazioni e verificare
      //che siano sempre presenti le fisse

      var internalFix = 0;
      var tmpProd = 1;
      for (var cc = 0; cc < a.length; cc++) {
        internalFix += F[a[cc]];
        tmpProd *= ES[a[cc]];
      }

      if (containFixed == 1 && internalFix != fixedForEvent)
        continue;

      tmpArray.push(a);
      PrecalculateComb[k].push(a);
      SingleCombCount[k].push(tmpProd);
      ct += tmpProd;

      if (ct > 2000) {
        internalValid = false;
        break;
      }
    }

    //aggiorno anche countCombination
    countCombination[k] = ct;

    if (!internalValid) {
      validCombination[k] = 0;
      continue;
    } else {
      combs.push.apply(combs, tmpArray)
    }
  }

  oldSetLength = e;
  return combs;
};

export function KFactorial(k) {
  if (k <= 1)
    return 1; // se il numero di fisse è 0 e c = e restituisco 0 

  if (preFact[k] != undefined) {
    return preFact[k];
  }

  var kC = k * (KFactorial(k - 1));
  preFact[k] = kC;
  return kC;

};
